// Worker route definitions containing only path and i18nKey
// These basic route definitions are extended with components and icons in WorkerRouter.jsx
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';

export const WORKER_ROUTE_DEFINITIONS = {
  laborAvailability: {
    path: '/labor-availability',
    i18nKey: 'laborAvailabilityTab',
    icon: AccountBalanceIcon, // TODO Set a Proper Icon for Mobile Mode.
  },
  profile: {
    path: '/profile',
    i18nKey: 'profile',
    icon: PermIdentityIcon,
  },
  maintenance: {
    path: '/maintenance',
    i18nKey: 'maintenance',
  },
};
